// src/context/AuthContext.ts
import { createContext } from "react";

export interface AuthUser {
    id: number;
    role: string;      // e.g. "dealer", "sales", "bdc"
    dealerId: string;  // e.g. "motor-ac"
    page?: string;     // optional: /sales/dashboard
    vehicleId?: string; // optional: inventory vehicle being viewed
}

export interface AuthContextType {
    user: AuthUser | null;
    setUser: (u: AuthUser | null) => void;
}

// Just create the context, no component here
export const AuthContext = createContext<AuthContextType | undefined>(undefined);
